export default {
    MENU: {
        HOME: 'Inicio',
        DOCUMENT: 'Documentación',
        PROFILE: 'Información personal',
        ADVANTAGE_PRODUCTS: 'Productos con ventaja fiscal',
        OTHER_PRODUCTS: 'Otros productos',
        LEGAL: 'Aviso legal',
        PRIVACY: 'Política de privacidad',
        COMPENSATION: 'Mi compensación',
        COOKIE_MESSAGE: 'Esta página web usa cookies para mejorar la experiencia',
        FLEXIBLE: 'Retribución Flexible',
        DOCUMENTATION: 'Documentación',
        PERSONAL: 'Información Personal',
        MY_COMPENATION: 'Mi compensación',
        EXPENSE_MANAGEMENT: 'Gestión de gastos',
        CORPORATE_SOCIAL_RESPONSIBILITY: 'Responsabilidad Social Corporativa',
        HELLO: 'Hola',
        WELCOME_MESSAGE: 'Bienvenido/a a tu plan de retribución flexible. En el apartado “Documentación” encontrarás toda la información necesaria. Recuerda que en primer lugar debes cumplimentar el apartado de “Información personal”',
        TERMS_AND_CONDITIONS: 'Términos y condiciones'
    },
    HEADER: {
        SAVED: 'Ahorrados',
        PENDING_SAVING: 'Posibles de ahorrar',
        LIMIT: 'Límite máximo',
        REACHED: 'Alcanzado',
        LANGUAGE: 'Idioma',
        CHECKOUT: 'Tramitar pedido',
        LOGOUT: 'Cerrar sesión',
        HELP: 'Ayuda',
        CONTACT: 'Contáctanos',
    },
    HOME: {
        MISSING_PROFILE_INFO: 'Información de usuario incompleta: Por favor, revise que tiene rellenado el email/teléfono en su perfil',
        CURRENT_SITUATION: 'Situación',
        NEWS: 'Noticias',
        PRODUCTS_WITH_TAX: 'Productos Con ventaja fiscal',
        ALERTS: 'Alertas',
        CONTRACTED_PRODUCTS: 'Productos contratados',
        PENDING_SIGNATURE: 'Pendiente de firmar',
        PENDING_PRODUCTS: 'Pendientes de contratar',
        SAVING: 'Ahorrados',
        PENDING_SAVING: 'Pendientes ahorrar',
        NON_SIMULATED_PRODUCT: 'No simulado',
        PENDING_SIMULATIONS: 'Simulaciones Pendientes',
        NO_ACTIVE_ALERTS: 'No tiene alertas',
        PRODUCT: 'Producto',
        Status: 'Estado',
        END_DATE: 'Fecha final',
        Expiring: 'Fecha de finalización',
        Go: 'Ir',
        MISSING_DOCUMENT: 'Falta documentación',
        ATTACH_INVOICE: 'Adjuntar factura mes',
        PENDING_CART: 'Pendiente de contratar',
        PENDING_REVIEW: 'Pendiente de revisión',
        CONTRACTED: 'Contratado',
        CANCELLED: 'Cancelado',
    },
    LIFE_AXA: {
        FALLCC: 'Fallecimiento por cualquier causa',
        FALLA: 'Fallecimiento por accidente',
        FALLAC: 'Fallecimiento por accidente de circulación',
        IPAA: 'Incapacidad Permanente Absoluta por accidente',
        IPAAC: 'Incapacidad Permanente Absoluta por accidente de circulación',
        IPACC: 'Incapacidad Permanente Absoluta por cualquier causa',
        GINV: 'Gran Invalidez',
        MANDATORY: 'Obligatorio',
        MANDATORY_2: 'obligatorio para contratar',
        AGE_LIMIT: 'No disponible para tu edad',
        CANNOT_EXCEED: 'no puede exceder',
        CANNOT_LESS_FALLA: 'No podra ser inferior a 35.000 €'
    },
    COMPENSATION: {
        Benefits: 'Beneficios Sociales',
        TotalCompensation: 'Total Compensación',
        TotalSecurityCost: 'Coste de la Seguridad Social'
    },
    DOCUMENT: {
        Documents: 'Documentos',
        DETAIL_ACTION: 'Detalle por producto',
        DETAIL: 'Detalle',
        ID: 'Id',
        YEAR: 'Año',
        NAME: 'Nombre',
        CREATED_BY: 'Creado por',
        CREATED_AT: 'Creado el',
        LAST_MODIFICATION: 'Última modificación',
        Admin: 'Administrador',
        no_documents: 'No hay documentos cargados',
        no_products: 'No tiene productos contratados',
    },
    profile: {
        user_tab: 'Información del usuario',
        employee_tab: 'Información personal',
        family_tab: 'Información familiar',
        office: 'Oficina',
        incorrect_password: 'La contraseña no cumple con las medidas minímas de seguridad: Debe tener un mínimo de 8 carácters, contener numeros y letras, al menos una letra mayúscula/minúscula y sin espacios.',
        incorrect_repeat_password: 'La contraseña no coincide',
        password_deprecated: 'La contraseña ha caducado. Por favor, introduce nueva contraseña',
        collective: 'Colectivo',
        legal_entity: 'Entidad legal',
        email: 'Email',
        password: 'Contraseña',
        repeat_password: 'Repetir contraseña',
        id: 'DNI',
        phone: 'Teléfono móvil',
        bank: 'Número de cuenta bancaria',
        nationality: 'Nacionalidad',
        birthday: 'Fecha de nacimiento',
        Gender: 'Sexo',
        Male: 'Hombre',
        Female: 'Mujer',
        disability: 'Discapacidad',
        No: 'No',
        Yes: 'Si',
        marital_status: 'Estado civil',
        Single: 'Soltero',
        Married: 'Casado',
        Divorced: 'Divorciado',
        Widowed: 'Viudo',
        Address1: 'Dirección 1',
        Address2: 'Dirección 2',
        City: 'Localidad',
        Country: 'País',
        Province: 'Provincia',
        postal_code: 'Código postal',
        fixed_salary: 'Salario Fijo',
        flexible_bag: 'Bolsa Flexible',
        top_bag: 'Bolsa productos top',
        variable_salary: 'Salario Variable',
        number_payments: 'Número de pagas',
        social_security: 'Número de seguridad social',
        employee_number: 'Número de empleado',
        cost_center: 'Centro de coste',
        renting: 'Renting',
        private_use: '% uso privativo',
        relationship: 'Parentesco',
        spouse: 'Cónyuge',
        child: 'Hijo/a',
        domestic_partner: 'Pareja de hecho',
        name: 'Nombre',
        surname: 'Apellido',
        first_name: 'Nombre',
        last_name: 'Apellido',
        last_name_2: 'Segundo Apellido',
        address: 'Dirección',
        subPolicy: 'Subpóliza',
        policy: 'Póliza',
        contribution: 'Aportación',
        publicResponsibility: 'Responsabilidad pública',
        typeOfStreet: 'Tipo de vía',
        houseNumber: 'Número',
        mobilePhonePrefix: 'Prefijo país móvil',
        birthCountry: 'País de nacimiento',
        residenceCountry: 'País de residencia',
        investmentBasket: 'Cesta',
        investmentProfile: 'Perfil inversor',
        contributionDate: 'Fecha de carga aportación',
        companyCIF: 'CIF empresa',
        population: 'Población',
        residence: 'Domicilio',
        complement: 'Resto',
    },
    product_names: {
        'health-insurance': 'Salud',
        transport: 'Transporte',
        food: 'Comida',
        kindergarten: 'Guardería',
        formation: 'Formación',
        renting: 'Renting',
        'life-insurance': 'Vida',
        'saving-plan': 'Ahorro',
        gym: 'Gimnasio',
        lottery: 'lotería',
        informative: 'Informativo',
    },
    buttons: {
        accept_lower: 'Aceptar',
        consent_lower: 'Entendido',
        accept: 'ACEPTAR',
        close: 'CERRAR',
        add_cart: 'AÑADIR AL CARRITO',
        update_cart: 'ACTUALIZAR CARRITO',
        remove_cart: 'ELIMINAR DEL CARRITO',
        update_contract: 'ACTUALIZAR CONTRATO',
        reset: 'RESET',
        see_details: 'Aceptar la cláusula de privacidad',
        sign: 'FIRMAR',
        back: 'ATRAS',
        update: 'ACTUALIZAR',
        cancel: 'CANCELAR',
        download: 'DESCARGAR',
        click_here: 'CLICK AQUÍ',
        back_simulation: 'VOLVER A SIMULAR',
        next_step: 'CONTRATAR',
        add_child: 'AÑADIR HIJO',
        add_family: 'AÑADIR FAMILIAR',
        select: 'SELECCIONAR',
        delete: 'ELIMINAR',
        add_member: 'AÑADIR MIEMBRO',
        reset_password: 'Restablecer contraseña',
        forgot_password: 'Has olvidado la contraseña?',
        back_to_login: 'Volver a inicio',
        change_language: 'cambiar',
    },
    calculator: {
        header: 'SIMULADOR AHORRO IRPF',
        increase_dis_income: 'Incremento neto disponible',
        equi_salary_increase: 'Incremento salario equivalente',
        not_available:
            'Calculadora no disponible por: Información de salario incompleta',
        edit_profile: 'Editar información de salario en el perfil de los usuarios.',
        fixed_salary: 'Salario fijo',
        variable_salary: 'Salario variable',
        flexible_products: 'Productos flexibles',
        without_remuneration: 'Sin plan de retribución flexible',
        with_remuneration: 'Con plan de retribución flexible',
        non_flexible_products: 'Otros productos',
        total_gross_salary: 'Total salario bruto',
        social_security: 'Seguridad social',
        pit: 'IRPF',
        withholding_account: 'Retención a cuenta',
        net_salary: 'Salario neto',
        net_available_salary: 'Salario neto disponible',
        employee_bag: 'Bolsa flexible',
        employee_top_bag: 'Bolsa productos top',
        employee_user_bag: 'Bolsa usuario',
        company_bag: 'Bolsa empresa',
        contribution_company: 'Contrib. empresa',
        available: 'Disponible',
        spent: 'Gastado',
    },
    products: {
        health_insurance: 'Seguro de Salud',
        saving_insurance: 'Seguro de Ahorro',
        unit_linked_4_portfolio: 'Seguro de Ahorro Unit Linked 4 Carteras',
        unit_linked_lifecycle: 'Seguro de Ahorro Unit Linked Ciclo de Vida',
        month_text: 'Introduzca la cantidad disponible mensual',
        min_amount_text: 'Importe mínimo mensual para contratar',
        max_amount_text: 'Importe máximo disponible mensual para contratar',
        max_available: 'Máximo disponible mensual',
        transport_max_text: 'El limite de gasto son 1500€ al año',
        start_date: 'Fecha de inicio',
        privative_use: 'Uso privativo',
        year: 'Año',
        years: 'Años',
        vehicle_value: 'Valor del vehículo',
        with_no_tax: 'Cuota sin IVA',
        with_tax: 'Cuota con IVA',
        number_tickets: 'Número de tickets',
        price_tickets: 'Precio por ticket',
        death_capital: 'Capital por fallecimiento',
        capital_disability: 'Capital por invalidez (opcional)',
        yearly_price: 'Prima anual',
        value_less_than_prorated: 'El valor debe ser igual o mayor a {{prorated}} por mes',
        select_children:
            'Por favor, seleccione los niños que le gustaría añadir para guardería',
        no_children: 'No tiene hijos menores de 3 años',
        person: 'Persona',
        monthly: 'Mensual',
        yearly: 'Anual',
        main_benefit_error: 'Por favor, compruebe antes el principal beneficio',
        benefit_error: 'Debe seleccionar el beneficio',
        price_over_error: 'Supera la cantidad disponible',
    },
    contracts: {
        month: 'Mes',
        company: 'Compañía',
        capital_death_case: 'Capital por fallecimiento',
        capital_dis_case: 'Capital por invalidez',
        cancel_text: 'El beneficio está cancelado',
        pending_text:
            'El producto esta siendo revisado. Le informaremos cuando esté contratado',
        contract_text: 'Ya ha contratado el beneficio',
        zero_message: 'La cantidad total es 0',
        min_unreached: 'No se ha alcanzado la cantidad mínima mensual',
        max_exceeded: 'Se ha superado la cantidad máxima mensual',
        reset_message: 'La configuración ha sido reseteada',
        update_confirm_message:
            'Vas a cambiar las condiciones de un contrato ya existente, Estás seguro?” En caso afirmativo, revisa tu correo para completar el proceso',
        select_start_month: 'selecione el mes de inicio',
        inactive_product: 'No está permitido contratar este producto. Comuníquese con el administrador para la activación.',
        saving_in_progress_error: 'No puedes modificar la selección mientras tienes una contratación de ahorro en curso. Finaliza el trámite actual primero.',
        effective_june: 'El producto será efectivo desde el 1 de junio',
        effective_december: 'El producto será efectivo desde el 1 de diciembre',
        saving_plan_cart_pending: 'No puedes añadir un nuevo plan de ahorro mientras tienes uno pendiente en el carrito. Finaliza o cancela la tramitación actual.',
        savings_plan_modification: 'Solo es posible modificar el plan de ahorro entre el 11 de abril y 10 de mayo (efecto: 1 de junio) o entre el 11 de octubre y el 10 de noviembre (efecto: 1 de diciembre).'
    },
    cart: {
        data_confirm: 'Confirmación de datos',
        sign_contract: 'Firma de contrato',
        step_company: 'Selección de Compañía',
        step_product: 'Selección de Producto',
        basket_selection: 'Selección de cesta',
        step_family: 'Selección de Familia',
        step_months: 'Selección de meses',
        empty_cart: 'Su carrito está vacío',
        agree_message:
            'Al hacer clic en siguiente paso, usted acepta contratar automáticamente',
        terms: `Firma y <b><u>recibirás un correo electrónico con el contrato de novación 
            adjunto</u></b> y la relación de productos seleccionados que deberás aceptar.
              <br />
              <br />
              Para poder finalizar tu proceso de contratación, <b><u>es necesario que abras
              y aceptes las condiciones del correo</u></b>. Recuerda hacerlo antes del día&nbsp;
              {{cutOffDate}} para disponer del producto el 1 del mes siguiente.`,
        pending: 'PENDIENTE',
        completed: 'COMPLETADO',
        download_doc_text: 'Por favor descargue el documento, rellenelo y fírmelo',
        edit_family: 'Editar información del beneficiario',
        name: 'Nombre',
        surname: 'Apellido',
        address: 'Dirección',
        zip: 'Código postal',
        contact_person: 'Persona de contacto',
        contact_phone: 'Teléfono de contacto',
        center_name: 'Nombre del centro',
        cancel_confirm: 'Está a punto de cancelar el contrato. ¿Está seguro?',
        course: 'Curso',
        phone_contact: 'Teléfono de contacto',
        attach_invoice: 'Por favor, adjunte la factura',
        same_kindergarten: 'Es la misma guardería que',
        code_center: 'Código de la guardería',
        dontknow: 'Si no lo sabe, haga click aquí',
        edit_profile: 'Editar perfil',
        modality_info_details: 'Información detallada',
        modality: 'Modalidad',
        beneficiary_info: 'Información de beneficiario',
        additional_info: 'Información adicional',
        total: 'Total',
        total_anual: 'Total Anual',
        total_spent: 'TOTAL GASTADO',
        flexible_bag: 'Bolsa flexible',
        top_bag: 'Bolsa productos top',
        company_bag: 'Bolsa empresa',
        health_provider_noselect:
            'no se puede seleccionar este proveedor porque el usuario ya contrató a otro proveedor',
        no_info: 'No se requiere información',
        expired_products: 'Tiene productos en el carrito con fechas inferiores a la fecha límite de la empresa, elimínelos para poder contratarlos: ',
        expired_warning: '¡CADUCADO! Por favor, elimínalo',
        time_left: 'Tiempo restante',
        days: 'dia(s)',
        remove_products: 'Retire estos productos del carrito antes de contratar',
        no_permission: 'Ya no tienes permiso para contratar este producto',
        payment_frequency: 'Frecuencia de pago',
        saving_plan_modification_window_error: 'Solo es posible modificar el seguro de ahorro entre el 11 de abril y 10 de mayo (efecto: 1 de junio) o entre el 11 de octubre y el 10 de noviembre (efecto: 1 de diciembre).',
    },
    prices: {
        price: 'Precio',
        discount: 'Desc.',
        total: 'Total'
    },
    countries: {
        AF: 'Afganistán',
        AL: 'Albania',
        DE: 'Alemania',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguila',
        AQ: 'Antártida',
        AG: 'Antigua y Barbuda',
        SA: 'Arabia Saudita',
        DZ: 'Argelia',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaiyán',
        AN: 'Antillas Holandesas',
        BS: 'Bahamas',
        BH: 'Baréin',
        BD: 'Bangladés',
        BB: 'Barbados',
        BE: 'Bélgica',
        BZ: 'Belice',
        BJ: 'Benín',
        BM: 'Bermudas',
        BY: 'Bielorrusia',
        BO: 'Bolivia',
        BA: 'Bosnia y Herzegovina',
        BW: 'Botsuana',
        BR: 'Brasil',
        BN: 'Brunéi',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        BT: 'Bután',
        CV: 'Cabo Verde',
        KH: 'Camboya',
        CM: 'Camerún',
        CA: 'Canadá',
        QA: 'Catar',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CY: 'Chipre',
        CO: 'Colombia',
        KM: 'Comoras',
        CG: 'Congo',
        KP: 'Corea del Norte',
        KR: 'Corea del Sur',
        CI: 'Costa de Marfil',
        CR: 'Costa Rica',
        HR: 'Croacia',
        CU: 'Cuba',
        CW: 'Curazao',
        DK: 'Dinamarca',
        DM: 'Dominica',
        EC: 'Ecuador',
        EG: 'Egipto',
        SV: 'El Salvador',
        AE: 'Emiratos Árabes Unidos',
        ER: 'Eritrea',
        SK: 'Eslovaquia',
        SI: 'Eslovenia',
        ES: 'España',
        US: 'Estados Unidos',
        EE: 'Estonia',
        ET: 'Etiopía',
        PH: 'Filipinas',
        FI: 'Finlandia',
        FJ: 'Fiyi',
        FR: 'Francia',
        GA: 'Gabón',
        GM: 'Gambia',
        GE: 'Georgia',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Granada',
        GR: 'Grecia',
        GL: 'Groenlandia',
        GP: 'Guadalupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GF: 'Guayana Francesa',
        GG: 'Guernsey',
        GN: 'Guinea',
        GQ: 'Guinea Ecuatorial',
        GW: 'Guinea-Bisáu',
        GY: 'Guyana',
        HT: 'Haití',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungría',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Irán',
        IQ: 'Irak',
        IE: 'Irlanda',
        BV: 'Isla Bouvet',
        IM: 'Isla de Man',
        CX: 'Isla de Navidad',
        NF: 'Isla Norfolk',
        IS: 'Islandia',
        AX: 'Islas Åland',
        KY: 'Islas Caimán',
        CC: 'Islas Cocos',
        CK: 'Islas Cook',
        FO: 'Islas Feroe',
        GS: 'Islas Georgias del Sur y Sandwich del Sur',
        FK: 'Islas Malvinas',
        MP: 'Islas Marianas del Norte',
        MH: 'Islas Marshall',
        UM: 'Islas menores alejadas de los Estados Unidos',
        PN: 'Islas Pitcairn',
        SB: 'Islas Salomón',
        TC: 'Islas Turcas y Caicos',
        VG: 'Islas Vírgenes Británicas',
        VI: 'Islas Vírgenes de los Estados Unidos',
        IL: 'Israel',
        IT: 'Italia',
        JM: 'Jamaica',
        JP: 'Japón',
        JE: 'Jersey',
        JO: 'Jordania',
        KZ: 'Kazajistán',
        KE: 'Kenia',
        KG: 'Kirguistán',
        KI: 'Kiribati',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesoto',
        LV: 'Letonia',
        LB: 'Líbano',
        LR: 'Liberia',
        LY: 'Libia',
        LI: 'Liechtenstein',
        LT: 'Lituania',
        LU: 'Luxemburgo',
        MO: 'Macao',
        MK: 'Macedonia del Norte',
        MG: 'Madagascar',
        MY: 'Malasia',
        MW: 'Malaui',
        MV: 'Maldivas',
        ML: 'Malí',
        MT: 'Malta',
        MA: 'Marruecos',
        MQ: 'Martinica',
        MU: 'Mauricio',
        MR: 'Mauritania',
        YT: 'Mayotte',
        MX: 'México',
        FM: 'Micronesia',
        MD: 'Moldavia',
        MC: 'Mónaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NI: 'Nicaragua',
        NE: 'Níger',
        NG: 'Nigeria',
        NU: 'Niue',
        NO: 'Noruega',
        NC: 'Nueva Caledonia',
        NZ: 'Nueva Zelanda',
        OM: 'Omán',
        NL: 'Países Bajos',
        PK: 'Pakistán',
        PW: 'Palaos',
        PS: 'Palestina',
        PA: 'Panamá',
        PG: 'Papúa Nueva Guinea',
        PY: 'Paraguay',
        PE: 'Perú',
        PF: 'Polinesia Francesa',
        PL: 'Polonia',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        GB: 'Reino Unido',
        CF: 'República Centroafricana',
        CZ: 'República Checa',
        CD: 'República Democrática del Congo',
        DO: 'República Dominicana',
        RE: 'Reunión',
        RW: 'Ruanda',
        RO: 'Rumanía',
        RU: 'Rusia',
        EH: 'Sahara Occidental',
        WS: 'Samoa',
        AS: 'Samoa Americana',
        BL: 'San Bartolomé',
        BQ: 'Bonaire, San Eustaquio y Saba',
        HM: 'Islas Heard y McDonald',
        KN: 'San Cristóbal y Nieves',
        SM: 'San Marino',
        MF: 'San Martín',
        PM: 'San Pedro y Miquelón',
        VC: 'San Vicente y las Granadinas',
        SH: 'Santa Elena, Ascensión y Tristán de Acuña',
        LC: 'Santa Lucía',
        ST: 'Santo Tomé y Príncipe',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leona',
        SG: 'Singapur',
        SX: 'Sint Maarten',
        SY: 'Siria',
        SO: 'Somalia',
        LK: 'Sri Lanka',
        SZ: 'Suazilandia',
        ZA: 'Sudáfrica',
        SD: 'Sudán',
        SS: 'Sudán del Sur',
        SE: 'Suecia',
        CH: 'Suiza',
        SR: 'Surinam',
        SJ: 'Svalbard y Jan Mayen',
        TH: 'Tailandia',
        TW: 'Taiwán',
        TZ: 'Tanzania',
        TJ: 'Tayikistán',
        IO: 'Territorio Británico del Océano Índico',
        TF: 'Territorios Australes Franceses',
        TL: 'Timor Oriental',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad y Tobago',
        TN: 'Túnez',
        TM: 'Turkmenistán',
        TR: 'Turquía',
        TV: 'Tuvalu',
        UA: 'Ucrania',
        UG: 'Uganda',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        VU: 'Vanuatu',
        VA: 'Vaticano',
        VE: 'Venezuela',
        VN: 'Vietnam',
        WF: 'Wallis y Futuna',
        YE: 'Yemen',
        DJ: 'Yibuti',
        ZM: 'Zambia',
        ZW: 'Zimbabue'
    },
    common: {
        select: '-- Seleccionar --',
    }
}